import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import {
  RotationalCarousel,
  RotationalCarouselContent,
  RotationalCarouselItem,
  RotationalCarouselNext,
  RotationalCarouselPrevious,
} from "@/components/molecules/Carousel/RotationalCarousel";

import { ToolCard } from "./ToolCard";
import { useToolsSectionList } from "./useToolsSectionList";

const ToolsSection = () => {
  const items = useToolsSectionList();

  return (
    <section className="tw-bg-white tw-pt-32 tw-pb-56 lg:tw-p-72 lg:tw-pb-96">
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-xs-12 tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-16">
            <Text
              element="p"
              typeface="headline-3-b"
              className="lg:tw-headline-4-b tw-text-purple-800"
            >
              <FormattedMessage defaultMessage="Built for hosts" />
            </Text>
            <Text
              element="h2"
              typeface="headline-6-b"
              className="lg:tw-display-1-b tw-text-gray-900 tw-max-w-[720px]"
            >
              <FormattedMessage defaultMessage="Professional tools that run your venue for you" />
            </Text>
          </div>
        </div>
      </div>
      <div className="tw-overflow-hidden tw-py-32 lg:tw-py-64 lg:tw-h-[618px] tw-h-[434px] tw-relative tw-max-w-[1200px] tw-mx-auto">
        <RotationalCarousel>
          <RotationalCarouselContent>
            {items.map(
              (
                {
                  id: toolItemId,
                  toolItemDescription,
                  toolItemTitle,
                  toolItemImageSrc,
                },
                i,
              ) => (
                <RotationalCarouselItem key={toolItemId} index={i}>
                  <div className="lg:tw-w-[360px] tw-w-[280px]">
                    <ToolCard
                      imageSrc={toolItemImageSrc}
                      title={toolItemTitle}
                      description={toolItemDescription}
                    />
                  </div>
                </RotationalCarouselItem>
              ),
            )}
          </RotationalCarouselContent>
          <RotationalCarouselPrevious className="!tw-bg-purple-800 !tw-text-brand-white !tw-opacity-100" />
          <RotationalCarouselNext className="!tw-bg-purple-800 !tw-text-brand-white !tw-opacity-100" />
        </RotationalCarousel>
      </div>
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-xs-12 tw-flex tw-justify-center">
            <Text
              element="p"
              typeface="body-3"
              className="lg:tw-body-4 tw-text-gray-900 tw-text-center tw-max-w-[660px]"
            >
              <FormattedMessage defaultMessage="Everything you need to manage bookings, communicate with guests, and grow your earnings—from desktop or mobile." />
            </Text>
          </div>
        </div>
      </div>
    </section>
  );
};

export { ToolsSection };
